import React, {Component} from "react";
import {connect} from "react-redux";

import InvalidDatabasesPanelComponent from "../../../components/scenes/incompatible/InvalidDatabasesPanel";

class InvalidDatabasesPanel extends Component {
    render() {
        return (
            <InvalidDatabasesPanelComponent
                databaseList={this.props.databaseList}
                invalidDatabaseList={this.props.invalidDatabaseList}
            />
        );
    }
}

export default InvalidDatabasesPanel = connect((store) => {
    return {
        databaseList: store.server.databaseList,
        invalidDatabaseList: store.server.invalidDatabaseList
    };
})(InvalidDatabasesPanel);
